import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Natychmiastowy dostęp', 'Dożywotni dostęp', 'Wersja do druku', '30-dniowa gwarancja'];
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-116" data-mp="4lql31pohn65">
      <div className="mx-auto max-w-4xl text-center" data-id="element-117" data-mp="4na0kq3ifu6v">
        <motion.span initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease
      }} className="block whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.14em] text-brand sm:tracking-[0.18em]" data-id="element-118" data-mp="12a0mpfljy8wq">
          System materiałów z plastyki
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease
      }} className="mt-2.5 font-display text-[2.5rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.2rem]" data-id="element-119" data-mp="nbyj55eitnfh">
          Przygotuj cały rok lekcji plastyki w zaledwie{' '}
          <span className="italic text-brand" data-id="element-120" data-mp="3o6khfnpfum7r">5 minut</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-121" data-mp="39aurjeh4toxr">
          10 tomów gotowych materiałów — od klasy 4 po maturę. Koniec z
          improwizacją i szukaniem pomysłów w niedzielny wieczór.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease
      }} className="mx-auto mt-2 max-w-3xl pb-5 pt-2.5 sm:mt-8" data-id="element-122" data-mp="2ql6ampa4891e">
          <img src="https://cdn.magicpatterns.com/uploads/9vh18VaByMfukH68VanB7B/58982e87-ac43-4666-a530-c2bc54e4c3e8.webp" alt="Pakiet Plastyka Gotowa: 10 tomów tematycznych od klasy 4 do matury, materiały cyfrowe na komputerze, tablecie i telefonie oraz 5 ekskluzywnych dodatków" className="mx-auto w-full max-w-2xl" data-id="element-123" data-mp="2lkqz839e9bm2" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease
      }} className="-mt-2 sm:mt-8" data-id="element-124" data-mp="i9vr34bbm0lu">
          <CtaButton href="#offer" data-id="element-125" data-mp="161t3awiomunh" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-126" data-mp="161j7utevbvae">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-127" data-mp="x1nvil9ktu8s" data-mpi={index}>
                <span data-id="element-128" data-mp="x3h1rzga2cg9">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-129" data-mp="3lqugltxj6h7p">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}